import functions from "./functions.js";
import tplLoader from "./tpl-loader.js";
import pagination from "./pagination.js";
import Modal from 'bootstrap/js/dist/modal';
import Slider from "./Slider";

const list = {
    $form: null,
    form: null,
    $moreFiltersBtns: null,
    $moreFiltersBtnsIcons: null,
    moreFilters: false,
    $moreFiltersContainer: null,
    $shownItems: null,
    $total: null,
    $body: {},
    $list: null,
    list: null,
    $listWrap: null,
    $map: null,
    map: null,
    infoWindow: null,
    cluster: null,
    lastEvent: null,
    // form params
    params: {},
    defaults: {
        dateFrom: '',
        dateTo: '',
        destination: '',
        objectTypeId: '',
        guests: '2,0,0',
        personsInObject: '',
        sortBy: 0,
        _page: 1,
        perPage: 7,
        rooms: '',
        themeId: '',
        tagCategoryId: '',
        distanceBeach: '',
        distanceCenter: '',
        objectId: '',
        parking: '',
        pool: '',
        pets: '',
        grill: '',
        ac: '',
        sattv: '',
        internet: '',
        disabledPersons: '',
        washingMachine: '',
        coordinates: '',
        language: functions.getLang()
    },
    mainFields: ['dateFrom', 'dateTo', 'destination', 'objectTypeId', 'guests', 'personsInObject', 'sortBy', '_page', 'dates'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: false,
    disabledFields: {},
    locations: null,
    withoutMap: false,

    setLoadingMode() {

        if ( !list.loading ) {
            list.loading = true;
            if (list.$body.length) {
                list.$body.addClass('loading');
                list.$listWrap.prepend(tplLoader).scrollTop(0);
                if (list.withoutMap) {
                    if (Object.keys(functions.getUrlData(true)).length !== 0) {
                        $(window).scrollTop(list.$listWrap.offset().top);
                    }
                } else {
                    list.$listWrap.scrollTop(0); // mobile
                    list.$list.scrollTop(0);
                }
                list.infoWindow && list.infoWindow.close();
               
            } else {
                list.$form
                    .find('.form-submit').prop('disabled', true)
                    .find('i').addClass('fa-spinner fa-spin fa-lg');
            }
        }
    },
    splitDates(params) {
        if(params.dates)
        {
            let val = params.dates.split(' - ');
            params.dateFrom  = val[0];
            params.dateTo    = val[1];
            params.dates = null;
        }
        else
        {
            return;
        }
        
    },
    unsetLoadingMode() {
        if ( list.loading ) {
            list.loading = false;
            list.$body.removeClass('loading').find('.list-loader').remove();
        }
    },
    toggleFilters(toggle) {
        list.moreFilters = toggle === undefined ? !list.moreFilters : toggle;
        list.$moreFiltersBtns.toggleClass('active', list.moreFilters);
        list.$moreFiltersBtnsIcons.toggleClass('fa-chevron-up', list.moreFilters);
    },
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getUrlData(true));
        list.setFiltersCount();
    },
    setDisabledFields() {
        let disabledFields = list.$form.attr('data-disabledFields');
        if ( disabledFields ) {
            disabledFields = JSON.parse(disabledFields);
            $.map(disabledFields, (value, name) => {
                if ( list.form[name] ) {
                    list.disabledFields[name] = true;
                    list.defaults[name] = value;
                    list.form[name].disabled = true;
                    if ( name == 'dateFrom' || name == 'dateTo' ) {
                        $(list.form[name]).next().prop('disabled', true);
                    }
                }
            });
        }
    },
    toggleMobileForm(toggle) {
        if ( toggle ) {
            list.$body.addClass('modal-active');
        } else {
            list.$body.removeClass('modal-active');
            list.toggleFilters(false);
        }
    },
    onChange(e) {

        clearTimeout(list.changeTimeout);
        
        if ( list.pauseChange ) {
            return;
        }
        // if changed field is date range and not have dateFrom & dateTo prevent url push
        if ( e && e.target.name == 'dates' ) {
            let val = e.target.value.split(' - ');
            if ( val.length != 2 && val[0] != '') {
                return;
            }  
        }

        if ( e && e.target.name == 'destination') {
            if(list.params.destination == '' && list.params.coordinates != '') {
                list.params.coordinates = ''; 
            }
        }

        if( e && list.mainFields.indexOf(e.target.name) === -1)
        {
            return;
        }
        // not advanced (ajax) search
        if ( !list.$body.length ) {
            return;
        }

        list.changeTimeout = setTimeout(() => {
            functions.setUrlData(list.getFormData(), list.$body.length);
        }, 300);
    },
    getFormData() {
        let formData = $.extend(
            functions.getFormData(list.$form), {
                coordinates: list.params.coordinates,
                _page: list.paginated ? list.params._page : 1,
                sortBy: list.paginated ? list.params.sortBy : 0
            }
        );
        list.paginated = false;
        // do not send same values as defaults
        $.map(formData, (val, key) => {
            if ( list.defaults[key] == val ) {
                delete formData[key];
            }
        });
        return formData;
    },
    init() {
        list.$form = $('.search-form');
        if( !list.$form.length )
        {
            return;
        }
        list.$body = $('.body-listing');
        if ( ! list.$body.length)
        {
            list.$body = $('.body-listing-without-map');
            list.withoutMap = true;
        }
        list.form = list.$form[0]

        list.$moreFiltersBtns = list.$form.find('.more-filters');
        list.$moreFiltersBtnsIcons = list.$moreFiltersBtns.find('i');
        list.$filtersCount = list.$moreFiltersBtns.find('.filters-count');
        list.$moreFiltersContainer = list.$form.find('.more-filters-container');


        list.setDisabledFields();

        list.defaults.objectTypeId = list.$form.attr('data-objecttypeid');

        list.getParams();

        functions.setFormData(list.form, list.params);
        list.$body.length && list.find();

        // register form fields changes
        if ( ! list.withoutMap) list.$form.on('change', list.onChange);


        list.$form.on('submit', e => {
            e.preventDefault();
            if ( list.$body.length) {
                list.onChange();
                list.toggleMobileForm(false);
                list.closeModal();
            } else {
                // non ajax form
                let data = $.param(functions.cleanParams(list.getFormData())),
                toHash = list.$form.hasClass('form-hash');
                let href = location.protocol + '//' + location.host + list.$form.attr('action');
                if ( data ) {
                    href += (href.indexOf('?') === -1 ? (toHash ? '#' : '?') : '&');
                }
                href += data;
                list.setLoadingMode();
                list.toggleFilters(false);
                location.href = href;
            }
        });

        $('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {}

            $.map(list.params, (value, key) => {
                if ( list.mainFields.indexOf(key) === -1 ) {
                    if ( list.params[key] && list.params[key] != list.defaults[key] ) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            functions.setFormData(list.form, formData);
            if ( changed ) {
                list.$form.submit();
            }

        });

        // register hashchange which trigger load
        $(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                functions.setFormData(list.form, list.params);
                list.markers && list.clearMarkers();
                list.find();
                list.params.coordinates && $(list.form.destination).next().find('.select2-selection__placeholder').text("Area on map");
                list.pauseChange = false;
            }, 100);
        });
        $('[name="sortBy"]').on('change', e => {
            list.params._page = 1;
            list.params.sortBy = $(e.target).val();
            if ( list.$body.length ) {
                functions.setUrlData(list.params, true);
            } else {
                list.paginated = true;
                list.$form.submit();
            }
        });

        // register paginate        
        $(document).on('click', '.pagination a[data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        // more filters actions
        // list.$moreFiltersBtns.on('click', list.toggleFilters);
        // list.$moreFiltersContainer.find('.apply-filters').on('click', () => {
        //     list.toggleFilters(false);
        //     if ( list.$body.length ) {
        //         list.onChange();
        //     } else {
        //         list.$form.submit();
        //     }
        // });
        list.$moreFiltersContainer.find('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {}
            $.map(list.params, (value, key) => {
                if ( list.mainFields.indexOf(key) === -1 ) {
                    if ( list.params[key] && list.params[key] != list.defaults[key] ) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            functions.setFormData(list.form, formData);
            if ( changed ) {
                if ( !e.target.classList.contains('clear-filters-mobile') ) {
                    list.onChange();
                }
                if ( !list.$body.length ) {
                    list.$form.submit();
                }
            }
        });

        $('#fullscreen').on('click tap vclick', function() {
            $('.list').addClass('hide-list-list');
            $('.map-and-filters').addClass('d-none');
            $('.map-close-btn').removeClass('d-none');
            $('.list-map').addClass('show-map-list');
            $('.list-wrap').addClass('list-wrap-overflow');
        });

        $('#close-map').on('click tap vclick', function() {
            $('.list').removeClass('hide-list-list');
            $('.map-and-filters').removeClass('d-none');
            $('.map-close-btn').addClass('d-none');
            $('.list-map').removeClass('show-map-list');
            $('.list-wrap').removeClass('list-wrap-overflow');
        });

        $('.view-on-map').on('click tap vclick', function(e) {
            e.preventDefault();
            list.getParams();

            location.href = $(this).attr('href') + '#' + $.param(functions.getDataForUrl(list.params));
        });
    },
    
    setFiltersCount() {
        let filtersCount = 0;
        $.map(list.params, (val, name) => {
            list.mainFields.indexOf(name) === -1 && (val !== list.defaults[name] || list.disabledFields[name]) && (filtersCount++);
        });
        list.$filtersCount.html(filtersCount || '');
    },
    loadMap() {
        if ( $('.list-map').length ) {
            window.loadGoogleMaps().then(list.initMap);
        }
    },
    initMap() {
        list.$map = $('.list-map');
        list.map = new google.maps.Map(list.$map[0], {
            zoom: 10,
            center: { lat: 45.12740978317192, lng: 13.902139984375038 },
            gestureHandling: 'greedy',
            mapTypeControl: false,
            styles: [{
                featureType: 'poi.business',
                elementType: 'labels',
                stylers: [
                    { visibility: 'off' }
                ]
            }]
        });
        // only trigger mapfind when zoomout or dragend, zoomin we already have data
        list.map.addListener('zoom_changed', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            list.markers && list.clearMarkers();
            list.lastEvent = 'zoom';
        });
        list.map.addListener('dragend', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            list.markers && list.clearMarkers();
            list.lastEvent = 'dragend';
        });
        list.map.addListener('bounds_changed', () => {
            if ( list.suppressMapEvents ) {
                setTimeout(() => {
                    list.suppressMapEvents = false;
                });
            }
        });
        list.map.addListener('idle', () => {
            if ( list.suppressMapEvents ) {
                return;
            }
            if ( !list.lastEvent ) {
                return;
            }

            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            list.params.coordinates = sw.lat() + ',' + nw.lat() + ',' + sw.lng() + ',' + nw.lng();
            list.params._page = 1;
            if(list.params.destination) {
                list.params.destination = '';
            }
            functions.setUrlData(list.params, true);
        });
    
        // init info window
        list.infoWindow = new google.maps.InfoWindow({
            maxWidth: 300
        });
        list.infoWindow.addListener('domready', () => {
            // init infoWindow slider
        });
    },
    mapFind(ajaxId) {
        let params = Object.assign({}, list.params);
        if ( list.lastEvent ) {
            const bounds = list.map.getBounds();
            const sw = bounds.getSouthWest();
            const nw = bounds.getNorthEast();
            params.coordinates = list.params.coordinates = sw.lat() + ',' + nw.lat() + ',' + sw.lng() + ',' + nw.lng();
        } else {
            if ( !params.destination ) {
                //params.destination = '8';
            }
        }
        this.splitDates(params);
        $.get('/services/map', params).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            list.locations = JSON.parse(response);
            list.setMarkers();
        });
    },
    setMarkers() {
        if ( !list.map ) {
            setTimeout(list.setMarkers, 50);
            return;
        }
        // init each marker
        list.markers = list.locations.map(location => {
            location.lat = +location.lat;
            location.lng = +location.lng;
            const marker = new google.maps.Marker({
                position: location,
                map: list.map,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: "#334072",
                    fillOpacity: 0.6,
                    strokeWeight: 0
                },
            });
            marker.publicId = location.publicId;
            marker.addListener('click', () => {
                const params = {
                    publicId: marker.publicId,
                    dateFrom: list.params.dateFrom,
                    dateTo: list.params.dateTo,
                    guests: list.params.guests,
                    language: functions.getLang(),
                    template: 'map'
                };
                $.get('/services/objectDetails', params).then(response => {
                    let res = JSON.parse(response);
                    if ( response ) {
                        list.infoWindow.setContent(res.content);
                        list.infoWindow.setPosition({lat: marker.getPosition().lat(), lng: marker.getPosition().lng()});
                        list.infoWindow.open(list.map);
                    }
                });
            });
            return marker;
        });
        // init cluster
        // if ( !list.cluster ) {
        //     list.cluster = new MarkerClusterer(list.map, [], {
        //         gridSize: 100,
        //         minimumClusterSize: 3,
        //         maxZoom: 14,
        //         zoomOnClick: false,
        //         styles: [{
        //             // url: '/wp-content/uploads/cluster.png',
        //             textSize: 14,
        //             height: 40,
        //             width: 40
        //         }]
        //     });
        //     // force cluster full zoom
        //     list.cluster.addListener('click', function(cluster) {
        //         list.map.setCenter(cluster.center_);
        //         list.map.setZoom(15);
        //     });
        // }

        // list.cluster.addMarkers(list.markers);
        if ( !list.lastEvent ) {
            list.suppressMapEvents = true;
            if ( list.markers.length === 1 ) {
                list.map.setCenter(list.markers[0].position);
                list.map.setZoom(15);
            }
            else if ( list.markers.length ) {
                const bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < list.markers.length; i++) {
                    bounds.extend({lat: list.markers[i].getPosition().lat(), lng: list.markers[i].getPosition().lng()})
                }
                list.map.fitBounds(bounds);
            }
            else if ( list.params.coordinates ) {
                let coordinates = list.params.coordinates.split(',');
                const bounds = new google.maps.LatLngBounds();
                bounds.extend({ lat: +coordinates[0], lng: +coordinates[2] });
                bounds.extend({ lat: +coordinates[1], lng: +coordinates[3] });
                list.map.fitBounds(bounds);
            }
            return;
        }
        list.lastEvent = null;
    },
    paginate(page) {
        if ( page != list.params._page ) {
            list.params._page = page;
        }
        if ( list.$body.length ) {
            functions.setUrlData(list.params, list.$body.length);
        } else {
            list.paginated = true;
            list.$form.submit();
        }
    },
    find() {
        // init list
        if ( ! list.$list ) {
            list.$list = $('.list');
            list.list = list.$list[0];
            list.$listWrap = list.$list.closest('.list-wrap');
            list.unsetLoadingMode();
        }
        list.setLoadingMode();
        let ajaxId = ++list.loadId;
        list.mapFind(ajaxId);
        list.splitDates(list.params);
        $.get('/services/list', list.params).then(response => {
            if ( ajaxId !== list.loadId ) {
                return;
            }
            response = JSON.parse(response);

            list.total = response.total;
            list.$list[0].innerHTML = response.html + pagination({
                currentPage: list.params._page,
                total: list.total,
                perPage: 7
            });

            // functions.initCompare();
            //list.setResultsText();
            list.domInits();
            list.unsetLoadingMode();
        });
    },
    setResultsText() {
        let maxResults = list.params._page * 10;
        list.$shownItems.html(
            (maxResults - 9) +
            ' - ' +
            (maxResults > list.total ? list.total : maxResults)
        );
        list.$total.html(list.total);
    },
    domInits() {

        let listSlider = [];
        $('[id^=list-slider]').each((i, elem) => {
            const length = $(elem).find('.keen-slider__slide').length;
            listSlider[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                loop: true,
                arrows: true,
                slidesPerView: 1,
                spacing: 0,
                pager: false
            });
        });

        observer.observe();

        $('.details-discount').on('click', e => {
            e.preventDefault();
            const $this = $(e.target);
            window.open($this.attr('data-href'), '_blank');
        });
    },
    clearMarkers() 
    {
        //Loop through all the markers and remove
        for (var i = 0; i < list.markers.length; i++) {
            list.markers[i].setMap(null);
        }
        list.markers = null;
    },
    closeModal()
    {
        $('[data-bs-dismiss="modal"]').click();
    }
    
};

$(() => {
    list.init();
    list.loadMap();
})